module.exports = __webpack_public_path__ + "static/media/women-fas-cat-9.2faeef24.png";